export default __webpack_public_path__ + "atomic/_patterns/03-organisms/ct-landing-page/_ct-landing-page.twig";